const INTEGRATION_STORAGE_KEY_PREFIX = "shopify_";

export const INTEGRATION_SYNC_PRODUCTS_KEY = `${INTEGRATION_STORAGE_KEY_PREFIX}sync_products`;

export const UNKNOWN_AUTHORIZATION_DATE = Symbol("UNKNOWN_AUTHORIZATION_DATE");
